export default __webpack_public_path__ + "static/media/rocks-01.11f8b5b8.png";